/** Базовый URL статической медиа на CDN */
export const getStaticMediaCdnUrl = (): string => {
  const url =
    typeof window !== 'undefined'
      ? window.__ENV__?.STATIC_MEDIA_CDN_URL
      : process.env.STATIC_MEDIA_CDN_URL;

  if (!url) {
    throw new Error('STATIC_MEDIA_CDN_URL is required');
  }

  return url.replace(/\/$/, '');
};

/** Собирает полный URL статической медиа на CDN */
export const staticMediaUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return `${getStaticMediaCdnUrl()}${normalizedPath}`;
};
